slideOutCart();

 window.onresize = function() {
    slideOutCart();
}
$( document ).ready(function() {
    $('#submenu_container').removeClass('initial');
    $('#submenu_container').addClass('hide-menu');
});

function slideOutCart() {
    var cart = $('#cart_inner');
    var cartSection = $('#cart_drawer');
    var cartCheckout = $('#cart_drawer .checkout');
    var cartClose = $('#cart_drawer .close_btn');
    var openCartBtn = $('[data-value="cart_inner"]');
    
    //set cart height
    cart.height($(window).height() - cartCheckout.outerHeight() - cart.position().top);

    cartClose.on('click', function(e){
        e.preventDefault();
        cartSection.addClass('hide_cart');
        cartSection.removeClass('show_cart');
        $('html, body').removeClass('frozen');
    })
    openCartBtn.on('click', function(e){
        e.preventDefault();
        cartSection.addClass('show_cart');
        cartSection.removeClass('hide_cart');
        cartSection.removeClass('initial');
        $('html, body').addClass('frozen');
    })
}

jQuery(function($){

    updateCartStuff();
					
    resizeWindow();
	
	scrollWindow();

	scrollWindowCustom();
	  		
 	$(window).resize(resizeWindow);
	
	$(window).scroll(scrollWindow);

	$(window).scroll(scrollWindowCustom);
    
    // sliders
	if ($('.slideWrap .slider').length) {
		$('.slideWrap .slider').slick({
			dots: false,
			arrows: true,
			slidesToShow: 5,
			slidesToScroll: 1,
			adaptiveHeight: true,
            infinite: true,
            prevArrow: '.slideWrap .arrow-prev',
            nextArrow: '.slideWrap .arrow-next',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
		});
	}

    // product thumbs
    $('#product .images .thumb').on('click tap', function() {
        var src = $(this).attr('rel');
        $('#product .images .thumb').removeClass('active');
        $(this).addClass('active');
        $('#product .images .feature').attr('src', src);
    });

    // product variant images on grid item swatch hovers
    $('.grid-item .thumbwrap span.with_var_image').mouseover(function() {
        var var_id = $(this).attr('rel');
        $('#variant-img-'+ var_id).addClass('visible');
    }).mouseout(function() {
        var var_id = $(this).attr('rel');
        $('#variant-img-'+ var_id).removeClass('visible');
    });

    // header dropdowns
    var submenu_container = $('#submenu_container');
    var submenu = $('#submenu');
    var submenu_shop = $('#submenu_shop');
    var submenu_search = $('#submenu_search');

    $('#header nav > ul > li[data-value]').mouseenter(function() {

        var itemValue = $(this).attr('data-value');

        submenu.hide(0);
        submenu_shop.hide(0);
        submenu_search.hide(0);

        if (itemValue == "menu"){
            submenu.css('display', 'flex');
            submenu.addClass('show-menu');
            submenu_container.addClass('show-menu');
            submenu.removeClass('hide-menu');
            submenu_container.removeClass('hide-menu');
        } else if (itemValue == "shop"){
            submenu_shop.css('display', 'flex');
            submenu_shop.addClass('show-menu');
            submenu_container.addClass('show-menu');
            submenu_shop.removeClass('hide-menu');
            submenu_container.removeClass('hide-menu');
        } else if (itemValue == "search"){
            submenu_search.css('display', 'flex');
            submenu_search.addClass('show-menu');
            submenu_container.addClass('show-menu');
            submenu_search.removeClass('hide-menu');
            submenu_container.removeClass('hide-menu');
        } else {
            submenu_container.removeClass('show-menu');
            submenu_container.addClass('hide-menu');
        }

    });
    submenu.mouseleave(function(){
        submenu.removeClass('show-menu');
        submenu_container.removeClass('show-menu');
        submenu.addClass('hide-menu');
        submenu_container.addClass('hide-menu');
    });
    submenu_shop.mouseleave(function(){
        submenu_shop.removeClass('show-menu');
        submenu_container.removeClass('show-menu');
        submenu_shop.addClass('hide-menu');
        submenu_container.addClass('hide-menu');
    });
    submenu_search.mouseleave(function(){
        submenu_search.removeClass('show-menu');
        submenu_container.removeClass('show-menu');
        submenu_search.addClass('hide-menu');
        submenu_container.addClass('hide-menu');
    });

    // team
    if ($('.template-team main .topic_link').length) { 
        $('.template-team main .topic_link').each(function() {
            var linkval = $(this).attr('data-value');
            if ($('.template-team main .team-section.team-' + linkval).length) {
                // do nothing
            } else {
                $(this).parent().hide(0);
            }
        });
    }
    $('.template-team main .topic_link').on('click tap', function() {
        var linkval = $(this).attr('data-value');
        $('html, body').animate({ scrollTop: $('.template-team main .team-section.team-' + linkval).offset().top - $('#header').outerHeight() }, 500);
    });

    // faq
    $('.template-faq .nav .items .question h2').on('click tap', function() {
        $(this).next('.answer').slideToggle('fast');
    });  
    $('.template-faq .nav .topic_link').on('click tap', function() {
        var linkval = $(this).attr('data-value');
        $('html, body').animate({ scrollTop: $('.template-faq .nav .items .question_group.group-' + linkval).offset().top - $('#header').outerHeight() }, 500);
    });

    // events - flea-esta faq
    $('.template-events .nav .more_info .question .toggler').on('click tap', function() {
        $(this).next('.answer').slideToggle('fast');
        if ($(this).parent().find('i').hasClass('arrow-up')){
            $(this).parent().find('i').removeClass('arrow-up').addClass('arrow-down');
        } else {
            $(this).parent().find('i').removeClass('arrow-down').addClass('arrow-up');
        }
    });  
    $('.template-events .nav .topic_link').on('click tap', function() {
        var linkval = $(this).attr('data-value');
        $('html, body').animate({ scrollTop: $('#' + linkval).offset().top - $('#header').outerHeight() }, 500);
    });

  	// trade program
  	$('.template-trade .intro a').on('click tap', function(e) {
      	e.preventDefault();
        var linkval = $(this).attr('href');
        $('html, body').animate({ scrollTop: $(linkval).offset().top - $('#header').outerHeight() }, 500);
    });
  	
  
    // mobile nav
	$('.toggle_nav').on('click tap', function(e) {
		e.stopPropagation();
  		e.preventDefault();
		if ($('#mobile_nav').hasClass('open')) {
			$('.toggle_nav .hamburger').removeClass('open');
			$('#mobile_nav').removeClass('open');
		} else {
			$('.toggle_nav .hamburger').addClass('open');
			$('#mobile_nav').addClass('open');
		}
	});
	$('#mobile_nav .nav li.has_children a.toggler').on('click tap', function(e) {
		e.stopPropagation();
  		e.preventDefault();
		$(this).parent().toggleClass('open');
		$(this).next('.dropdown').slideToggle('fast');
	});

    // mobile promo
    if ($('#mobile_promo').length) {
        var ww = $(window).width();
        if (ww < 1025) {
            if (typeof(Storage) !== "undefined") {
                if (sessionStorage.celedonShowMobilePromo != 1) {
                    $('#mobile_promo').fadeIn(300);
                }
            }
        }
    }
    $('#mobile_promo .close').on('click tap', function() {
        $('#mobile_promo').fadeOut(300, function() {
            sessionStorage.celedonShowMobilePromo = 1;
        });
    });

    // collection sidebar
    if ($('.template-collection .sidebar .toggle_content').length) {
        $('.template-collection .sidebar .toggler').on('click tap', function(e) {
            e.stopPropagation();
              e.preventDefault();   
            if ($(this).hasClass('is-open')) {
                $('.template-collection .sidebar .toggle_content').removeClass('open');
                $(this).removeClass('is-open');
            } else {
                $('.template-collection .sidebar .toggle_content').addClass('open');
                $(this).addClass('is-open');
            }
        });   
        $('.toggle_filter').on('click tap', function(e) {
            e.stopPropagation();
              e.preventDefault();   
            if ($(".template-collection .sidebar .toggler").hasClass('is-open')) {
                $('.template-collection .sidebar .toggle_content').removeClass('open');
                $(".template-collection .sidebar .toggler").removeClass('is-open');
            } else {
                $('.template-collection .sidebar .toggle_content').addClass('open');
                $(".template-collection .sidebar .toggler").addClass('is-open');
            }
        }); 
    }

});

function resizeWindow() {

	var ww = $(window).width();
  
    // collection sidebar
    if ($('.template-collection .sidebar .toggle_content').length) {
        if (ww < 769) {
        } else {
            $('.template-collection .sidebar .toggle_content').show(0);
            $('.template-collection .sidebar .toggler').removeClass('is-open');
        }
    }

    // collection page header
    if ($('.template-collection #header .promo').length) {
        var hh = $('#header').outerHeight();
        $('.template-collection .intro').css('padding-top', hh + 'px');
    }
								 					
}


function scrollWindow() {

    // set top location of submenu container
    var hh = $('#header').outerHeight() - 1;
    var submenu_container = $('#submenu_container');
    submenu_container.css('top', hh + 'px');
  
  	// account for changes in logo container height to adjust top of submenu container on the homepage
  	if ($('body.template-home').length) {
        var $element = $('#header');
        var $lastHeight = $('#header').css('height');
      	var $submenu_container = $('#submenu_container');
        function checkForHeaderChanges(){
            if ($element.css('height') != $lastHeight){
                $lastHeight = $element.css('height');
                $submenu_container.css('top', $lastHeight);             
            }
            setTimeout(checkForHeaderChanges, 500);
        }
        checkForHeaderChanges();
    }

    // homepage header changes
    if ($('body.template-home').length) {

        var scrolltop = $(window).scrollTop();
                
        if (scrolltop > 0) {
            $('#header .logo-container .logo-mark').addClass('shrunk');
        } else {
            $('#header .logo-container .logo-mark').removeClass('shrunk');
        }

    }
			
}

function addItem(form_id) {
    $.ajax({
       type: 'POST', 
       url: '/cart/add.js',
       dataType: 'json', 
       data: $('#' + form_id).serialize(),
       success: function(product) {
         updateCartStuff();
         $('#header li[data-value="cart_inner"]').trigger('click');
       },
       error: function(obj, status) { 
           alert('The product you are trying to add is out of stock.');
       }
    });
 }
 
 function cartSubtract(variant_id, qty) {
  
   var newQty = qty - 1;
   var data = 'updates[' + variant_id + ']=' + newQty;
   
   $.ajax({
       type: 'POST',
       url: '/cart/update.js',
       data: data,
       dataType: 'json',
       success: function(cart) {
         updateCartStuff();
       },
       error: function() {
         alert('There was an error.');
       }
   });
   
 }
 
 function cartAdd(variant_id, qty) {
  
   var newQty = qty + 1;
   var data = 'updates[' + variant_id + ']=' + newQty;
   
   $.ajax({
       type: 'POST',
       url: '/cart/update.js',
       data: data,
       dataType: 'json',
       success: function(cart) {
         updateCartStuff();
       },
       error: function() {
         alert('There was an error.');
       }
   });
   
 }
 
 function cartRemove(variant_id) {
  
   var data = 'updates[' + variant_id + ']=0';
   
   $.ajax({
       type: 'POST',
       url: '/cart/update.js',
       data: data,
       dataType: 'json',
       success: function(cart) {
         updateCartStuff();
       },
       error: function() {
         alert('There was an error.');
       }
   });
   
 }
 
 function updateCartStuff() {
    
   $.ajax({
     
       type: 'GET',
       url: '/cart.js',
       dataType: 'json',
       success: function(cart) { 
         
         //console.log(cart);
         
         $('#cart_inner').html('');
         
         $('#cart_drawer .checkout .subtotal').html((Shopify.formatMoney(cart.total_price)).replace('.00',''));
 
         if (cart.item_count > 0) {
           
           $.each(cart.items, function(index, cartItem) {
 
             // console.log(cartItem);
 
             var item = '';
            
             item += '<table width="100%" cellspacing="0" cellpadding="0">';
                item += '<tr class="item item-' + cartItem.variant_id + '">';
                    item += '<td class="img">';
                        item += '<a href="' + cartItem.url + '" style="background-image: url(' + cartItem.image + ');"></a>';
                    item += '</td>';
                    item += '<td class="info-box">';
                        item += '<div class="title fd_pro_light">' + cartItem.product_title + '</div>';
                        item += '<div class="desc"></div>';
                        if (cartItem.variant_options.length > 0) {
                            $.each(cartItem.variant_options, function(i,o) {
                                if (o != 'Default Title') {
                                item += '<div class="desc futura_pt_book">' + o + '</div>';
                                }
                            });
                        }
                        if (cartItem.properties) {
                            $.each(cartItem.properties, function(i, o) {
                                item += '<div class="desc futura_pt_book">' + o + '</div>';
                            });
                        }
                        item += '<div class="qty">';
                            item += '<span class="qty-input futura_pt_book">';
                                item += '<span class="minus" onclick="cartSubtract(' + cartItem.variant_id + ', ' + cartItem.quantity + '); return false;">–</span>';
                                item += '<input type="number" step="1" value="' + cartItem.quantity + '" name="quantity" class="futura_pt_book">';
                                item += '<span class="plus" onclick="cartAdd(' + cartItem.variant_id + ', ' + cartItem.quantity + '); return false;">+</span>';
                            item += '</span>';
                        item += '</div>';
                    item += '</td>';
                    item += '<td class="price futura_pt_book">';
                        item += (Shopify.formatMoney(cartItem.price)).replace('.00','');
                        item += '<span class="remove" onclick="cartRemove(' + cartItem.variant_id + '); return false;"></span>';
                    item += '</td>';
                item += '</tr>';
             item += '</table>';
                         
             $('#cart_inner').append(item);       
 
           });
         
           $('#cart_drawer .checkout').show(0);
           
         } else {
 
           $('#cart_inner').append('<table width="100%" cellspacing="0" cellpadding="0"><tr><td>Your cart is empty.</td></tr></table>');
 
           $('#cart_drawer .checkout').hide(0);
 
         }
         
         $('#header .cart_count').html(cart.item_count);
   
      }
                
   });
   
 }